import { ActionType, getType } from "typesafe-actions";
import { IGrainProfileExtended, IGrainProfileMapping } from "../../models";
import * as actions from "../actions/grainProfileAction";

export interface IGrainProfileState {
    profileId: string;
    readonly grainProfiles: IGrainProfileExtended[] | undefined;
    selectedGrainProfileMapping: IGrainProfileMapping | undefined;
    brokenParam: number;
    brokenByShape: boolean;
}

export const initialGrainProfileState: IGrainProfileState = {
    profileId: "1",
    grainProfiles: undefined,
    selectedGrainProfileMapping: undefined,
    brokenParam: 3.94,
    brokenByShape: false
};

export const GrainProfileReducer = (
    state: IGrainProfileState = initialGrainProfileState,
    action: ActionType<typeof actions>
): IGrainProfileState => {
    switch (action.type) {
        case getType(actions.setProfileId):
            return {
                ...state,
                profileId: action.payload
            };
        case getType(actions.setGrainProfiles):
            return {
                ...state,
                grainProfiles: action.payload
            };
        case getType(actions.setSelectedGrainProfileMapping):
            return {
                ...state,
                selectedGrainProfileMapping: action.payload
            };
        case getType(actions.setBrokenParam):
            return {
                ...state,
                brokenParam: action.payload
            };
        case getType(actions.setBrokenByShape):
            return {
                ...state,
                brokenByShape: action.payload
            };
        case getType(actions.reset):
            return initialGrainProfileState;
        default:
            return state;
    }
};
